import Loadable from "react-loadable";

const LazyCreateFeedbackExt = Loadable({
  loader: () => import(/* webpackChunkName: 'create-feedback-externe' */ "./CreateFeedbackExt"),
  loading: () => 'loading...'
});

export default LazyCreateFeedbackExt;
